import { ChangeEventHandler, ReactNode } from 'react'

import clsx from 'clsx'

interface Props {
  name: string
  value: number | string
  checked?: boolean
  label?: ReactNode
  disabled?: boolean
  forDisclosure?: boolean
  padding?: boolean
  onChange: ChangeEventHandler<HTMLInputElement>
}

const RadioButtonElement = ({
  name,
  value,
  checked = false,
  label,
  disabled = false,
  forDisclosure = false,
  padding = false,
  onChange
}: Props) => {
  const id = name + '_' + value

  return (
    <label
      className={clsx(
        'group items-baseline gap-0.5 hover:cursor-pointer focus:outline-none',
        forDisclosure
          ? '[&:has(input:checked)]:bg-fill-selected [&:has(input:not(:checked))]:bg-fill-primary hover:[&:has(input:not(:checked))]:bg-surface-hover active:[&:has(input:not(:checked))]:bg-surface-active flex rounded-lg p-2'
          : 'inline-flex',
        padding && 'py-1'
      )}
      htmlFor={id}
    >
      <span className={'text-size-13 inline-flex max-w-full items-baseline gap-2'}>
        <input
          className={'hidden-input peer disabled:pointer-events-none'}
          id={id}
          type={'radio'}
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span
          className={clsx(
            'relative top-0.75 h-4 min-h-4 w-4 min-w-4',
            'outline-default-peer-before before:border-border-input before:absolute before:block before:h-4 before:w-4 before:rounded-[40px] before:border peer-checked:before:border-none',
            'after:bg-input after:absolute after:top-1/4 after:left-1/4 after:h-2 after:w-2 after:rounded-[40px] after:opacity-0 peer-checked:after:opacity-100',
            !checked &&
              !disabled &&
              'group-hover:before:border-border-input-hover group-hover:before:bg-input-hover group-active:before:border-border-input-active group-active:before:bg-input-active peer-checked:before:bg-primary',
            disabled
              ? 'before:bg-fill-disabled pointer-events-none before:border-none'
              : 'before:bg-input peer-checked:before:bg-fill-brand-selected before:border-solid'
          )}
        />
        <div className={clsx('min-w-0 flex-1 leading-150 break-all')}>{label}</div>
      </span>
    </label>
  )
}

export default RadioButtonElement
